export default __webpack_public_path__ + "static/media/SIFA_NL_SEQ07.37cd17e2.mp3";